/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent, ReactNode } from 'react';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import clsx from 'clsx';
import useStyles from './styles';

export type OutlinedEditorProps = {
    children: ReactNode;
};

const InputComponent = ({ inputRef, ...other }: any) => <div ref={inputRef} {...other} />;

const OutlinedEditor: FunctionComponent<OutlinedEditorProps> = ({ children, ...rest }: OutlinedEditorProps) => {
    const classes = useStyles();
    const className = clsx(classes.root);

    return (
        <OutlinedInput
            className={className}
            multiline={true}
            inputProps={{ children: children }}
            inputComponent={InputComponent}
            {...rest}
        />
    );
};

export default OutlinedEditor;
